import React, {useMemo} from 'react'
import {useQuery} from '@tanstack/react-query'
import {useSelector} from 'react-redux'
import {getReadingGroupsFetch} from 'store/middlewares/assessment.crud'
import qc from 'keys/queryClient'
import {ProfilesPageStyles} from 'pages/School/Profiles/Style'
import FilterManager from 'components/FilterManager'

export const ReadingGroupsContext = React.createContext()

const ReadingGroupsPage = (props) => {
    const {
        splitRatings,
        setFilters,
        filters,
        title,
        subTitle,
        toolbarTextTitle,
        toolbarTextSubTitle,
        customToolbar
    } = props

    const {headerFilters} = useSelector(state => state.header)
    const {testTaker} = useSelector(state => state.testTaker)

    const groups = useQuery({
        queryKey: [qc.readingGroups, headerFilters, filters, testTaker],
        queryFn: async () => {
            const {data} = await getReadingGroupsFetch({assessmentFilters: filters, headerFilters, testTaker})
            return data
        }
    })

    const filterSchema = {
        primary: [
            {key: "semester", overrides: {hideClear: true}},
            {key: "school_year", overrides: {hideClear: true}}
        ]
    }

    const totalStudents = useMemo(() => {
        return groups.data?.reduce((sum, g) => sum + (g.count || 0), 0) || 0
    }, [groups.data])

    const commonState = useMemo(() => ({
        groups,
        splitRatings,
        toolbarTextTitle,
        toolbarTextSubTitle,
        customToolbar,
    }), [groups, splitRatings, toolbarTextTitle, toolbarTextSubTitle, customToolbar])

    return (
        <ProfilesPageStyles>
            <ReadingGroupsContext.Provider value={commonState}>
                <div className='description-header' style={{height: 'auto', paddingBottom: 12}}>
                    <div>{typeof title === 'function' ? title(totalStudents) : title}</div>
                    {/*<div className='bold'>{title}</div>*/}
                    {/*{subTitle && <div>{subTitle}</div>}*/}
                </div>
                <div className='wrap-profiles-content'>
                    <div className='profiles-header'>
                        <FilterManager
                            schema={filterSchema}
                            values={filters}
                            onChange={setFilters}
                        />
                    </div>
                    <div className='profiles-content'>
                        {props.children}
                    </div>
                </div>
            </ReadingGroupsContext.Provider>
        </ProfilesPageStyles>
    )
}

export default ReadingGroupsPage
